import type { ServerConfig } from 'shared-types';

type Params = {
  hasPendingAccessRequests: boolean;
  relative?: boolean;
  serverConfig: Pick<
    ServerConfig,
    | 'hideAchievementsFromUI'
    | 'hideCalendarEventsFromUI'
    | 'hideCoursesFromUI'
    | 'hidePathsFromUI'
  >;
};

/**
 * Returns the first available My Team Follow destination.
 * Use `relative: true` for MyTeamPage `activeLink` (`/my-team${activeLink}`).
 */
const getMyTeamFollowHref = ({
  hasPendingAccessRequests,
  relative = false,
  serverConfig
}: Params): string => {
  const achievementsVisible = !serverConfig.hideAchievementsFromUI;
  const calendarEventsVisible = !serverConfig.hideCalendarEventsFromUI;
  const coursesVisible = !serverConfig.hideCoursesFromUI;
  const pathsVisible = !serverConfig.hidePathsFromUI;

  let href = '/my-team';

  if (hasPendingAccessRequests && achievementsVisible) {
    href += '/follow/pending-requests';
  } else if (coursesVisible) {
    href += '/follow/courses';
  } else if (achievementsVisible) {
    href += '/follow/achievements';
  } else if (calendarEventsVisible) {
    href += '/follow/calendar-events';
  } else if (pathsVisible) {
    href += '/follow/paths';
  }

  if (relative) return href.replace(/^\/my-team/, '') || '';
  return href;
};

export default getMyTeamFollowHref;
